import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../TGases.css";
import { plotBackground } from "../../../config/colors";

export default function PerfilVen01() {
  const [velocidad, setVelocidad] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [presionEntrada, setPresionEntrada] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [vibraciones, setVibraciones] = useState({
    value: [],
    fecha: [],
    estado: [],
  });


  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 3,
    secuencia: 11,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);

      populateVelocidad(data);
      populatePresionEntrada(data);
      populateVibraciones(data);

      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateVelocidad(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Velocidad % VEN01"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setVelocidad({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePresionEntrada(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Presión de Entrada a VEN01"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPresionEntrada({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateVibraciones(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Vibraciones VEN01"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setVibraciones({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil VEN01"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Velocidad % Ven01 --------------------------------------- */}
            <Chart.Line
              name="Velocidad % VEN01"
              data={velocidad.value}
              yAxis={1}
            />

            {/** -------------------------------- Presion de Entrada a Ven01 --------------------------------------- */}
            <Chart.Line
              name="Presion de Entrada a Ven01"
              data={presionEntrada.value}
              yAxis={0}
            />

            {/** -------------------------------- Vibraciones Ven01 --------------------------------------- */}
            <Chart.Line
              name="Vibraciones Ven01"
              data={vibraciones.value}
              yAxis={0}
            />


            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={velocidad.fecha} />

            <Chart.YAxis
              labelSuffix=" kPa"
              title="Vibraciones, - / Presión, kPa"
              lineWidth={2}
              lineColor="white"
            />

            <Chart.YAxis
              labelSuffix=" %"
              title="Velocidad, %"
              lineWidth={2}
              opposite={true}
              lineColor="white"
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
